import { type UseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import type { ListValorantAgentsResponse } from 'generated/openapi';

import {
  getValorantAgentsKey,
  getValorantAgentsOptions,
} from './getValorantAgents.options';

export interface UseGetValorantAgentsProps<T = ListValorantAgentsResponse> {
  options?: Omit<
    UseQueryOptions<ListValorantAgentsResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >;
}

export function useGetValorantAgents<T = ListValorantAgentsResponse>(
  props: UseGetValorantAgentsProps<T> = {},
) {
  const { options } = props;

  return useSuspenseQuery({
    ...getValorantAgentsOptions<T>(),
    ...options,
  });
}

useGetValorantAgents.getQueryKey = getValorantAgentsKey;
